import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';

export function useApiMutation<TData = unknown, TVariables = void, TError = Error>(
  mutationFn: (variables: TVariables) => Promise<TData>,
  options?: UseMutationOptions<TData, TError, TVariables>,
): UseMutationResult<TData, TError, TVariables> {
  return useMutation<TData, TError, TVariables>({ mutationFn, ...options });
}
